module.exports = __webpack_public_path__ + "img/header-engagementRingsRingsets.14ab429.jpg";